module.exports = __webpack_public_path__ + "img/dhh.5e9d3e4f.png";